import styled from 'styled-components'
import { ButtonPink } from 'components/Button'

export const Wrapper = styled.div`
  display: grid;
  grid-gap: 1.5rem;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  padding: 20px 0;
`

export const Card = styled.div`
  background-color: ${({ theme }) => theme.drawerBG};
  border-radius: 24px;
  padding: 16px;
  width: 100%;
`

export const CardTitle = styled.div`
  background-color: #1f1e1e;
  border-radius: 20px;
  font-weight: 700;
  padding: 20px;
  background-color: #2d3036;
`

export const CardList = styled.div`
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: space-between;
  margin: 0 10px;
  padding: 15px 0;
`

export const ResponsiveButtonPink = styled(ButtonPink)`
  font-size: 16px;
  line-height: 21px;
  margin: auto;
  margin-top: 30px;
  width: 100%;
`

export const ButtonOutlined = styled.button`
  background-color: transparent;
  border: 1px solid #1f1e1e;
  border-radius: 20px;
  color: #d06cff;
  cursor: pointer;
  font-size: 16px;
  height: 54px;
  margin-top: 40px;
  width: 100%;
`

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 30px;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    flex-direction: column;
  `}
`

export const FooterContent = styled.div`
  display: flex;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    justify-content: center;
  `}
`

export const Achievement = styled.div`
  align-content: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-left: 20px;
`

export const PurpleFootContent = styled.div`
  color: #d06cff;
  text-align: right;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    text-align: center;
    padding-top: 20px;
  `}
`

export const PurpleSide = styled.div`
  color: #d06cff;
  display: inline;
  font-weight: inherit;
`

export const PlaceholderWrapper = styled.div`
  font-size: 48px;
  font-weight: 700;

  ${({ theme }) => theme.mediaWidth.upToSmall`
    font-size: 32px;
  `}
`
